import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn, EAA_Upload, EAA_ExcelDownload } from '~/components/EditAndAddItem';

const emptyBody = {
  all_capacity: '0',
  frame_num: '',
  one_capacity: '',
  wind_upload_files: [],
  wind_upload_imgs: [],
};

const App = props => {
  const { titleWidth, disabled, checkSubChange, changeData, data } = props;
  const ary = data.sub2 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub2', data: dataAry.map(o => ({ ...o, all_capacity: ((o.one_capacity || 0) * (o.frame_num || 0)).toString() })) });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_Contract_sub2_1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='' />
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>單機容量</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>架數</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>總容量共</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳示意圖</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }}>上傳座標檔</div>
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
    renderAry.push(
      <EAA_Row key={`Page_Contract_sub2_2_${i}`} style={{ marginTop: 0 }}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '風力機' : ''} bol={isFirst} haveChange={checkSubChange(2, [emptyBody])} />
            <EAA_Input displayBorder marginRight={12} disabled={disabled} type='number' hint='單機容量' unit='MW' value={ary[i].one_capacity} onChange={data => { ary[i].one_capacity = data; saveSub(ary); }} />
            <EAA_Input displayBorder marginRight={12} disabled={disabled} type='number' hint='架數' unit='架' value={ary[i].frame_num} onChange={data => { ary[i].frame_num = data; saveSub(ary); }} />
            <EAA_Input displayBorder marginRight={12} disabled type='number' unit='MW' value={(ary[i].one_capacity || 0) * (ary[i].frame_num || 0)} />
            <EAA_Upload displayBorder marginRight={12} disabled={disabled} hint='上傳示意圖' value={ary[i].wind_upload_imgs} onChange={data => { ary[i].wind_upload_imgs = data; saveSub(ary); }} />
            <EAA_Upload displayBorder marginRight={12} disabled={disabled} hint='上傳座標檔' value={ary[i].wind_upload_files} onChange={data => { ary[i].wind_upload_files = data; saveSub(ary); }} accept='.xlsx' />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇進度' />} */}
        </EAA_Item>
      </EAA_Row>,
    );
    if (isFirst) {
      renderAry.push(
        <EAA_Row key='Page_Contract_sub2_Excel' style={{ marginTop: 0 }}>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='' />
              <div style={{ flex: 1, marginRight: 12 }} />
              <div style={{ flex: 1, marginRight: 12 }} />
              <div style={{ flex: 1, marginRight: 12 }} />
              <div style={{ flex: 1, marginRight: 12 }} />
              <div style={{ flex: 1, marginRight: 12 + 150 }}><EAA_ExcelDownload /></div>
            </EAA_ItemContainer>
          </EAA_Item>
        </EAA_Row>,
      );
    }
  }
  return renderAry;
};
export default App;
